import React from 'react';
import useTranslation from '../../../../Hooks/useTranslation';
import styles from './DataTableHeader.module.scss';
import { DataTableColumn } from './DataTable';

interface Props<TItem, TTable> {
	columns: DataTableColumn<TItem, TTable>[];
}

export const DataTableHeader = <TItem, TTable>({
	columns,
}: Props<TItem, TTable>): React.ReactElement => {
	const { t } = useTranslation();

	return (
		<thead className={styles.wrapper}>
			<tr>
				{columns.map((item, key) => (
					<th key={key}>{t(item.label || '')}</th>
				))}
			</tr>
		</thead>
	);
};

export default DataTableHeader;
